import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  formatValue,
  TableActionEvent,
  TableColumn,
  TableItemsParams,
  TableParams,
  TableRow,
  TableValueType
} from "../..";

@Component({
  selector: 'app-table-items',
  templateUrl: './table-items.component.html',
  styleUrls: ['./table-items.component.scss']
})
export class TableItemsComponent {

  @Output() actioned = new EventEmitter<TableActionEvent>();

  columns: TableColumn[] = [];
  rows: TableRow[] = [];
  tableParams: TableParams = {
    columns: [],
    values: []
  };

  private _params: TableItemsParams<any> = null;

  @Input()
  get params(): TableItemsParams<any> {
    return this._params;
  }

  set params(params: TableItemsParams<any>) {
    this._params = params;
    this.update();
  }

  update() {
    this.rows = [];
    this.columns = this.params.columns;
    this.updateRows();
    this.tableParams = {
      columns: this.columns.map(c => ({ ...c })),
      values: this.rows.map(r => ({ ...r })),
      filter: this.params.filter,
      pagination: this.params.pagination
    };
  }

  updateRows() {
    const rows: TableRow[] = [];
    if (this.params.items) {
      for (const item of this.params.items) {
        rows.push(this.createRow(item));
      }
    }
    this.rows = rows;
  }

  emit(action: TableActionEvent) {
    this.actioned.emit(action);
  }

  protected createRow(item: any): TableRow {
    const row: TableRow = {
      __source__: item
    };
    for (const column of this.columns) {
      switch (column.type) {
        case TableValueType.ACTION:
          if (column.actionFormat) {
            row[column.name] = column.actionFormat(item, this.params.sources);
          } else {
            row[column.name] = { value: column.name, text: column.name, icon: 'bomb' };
          }
          break;
        case TableValueType.LITERAL:
          row[column.name] = formatValue(item[column.name], column.literalFormat);
          break;
        case TableValueType.FUNC:
          // Todo, esto se quedo a medias, es para mostrar un valor en la tabla que sea de otro objeto
          const itemObject = new this.params.ctor();
          Object.keys(item).forEach(key=>itemObject[key]=item[key]);
          const funct = item[column.name];
          row[column.name] = itemObject[funct]();
          break;
      }
    }
    return row;
  }
}
